<template>
	<div id="filter-row">
		<div class="input-group" v-if="col.type !== 'dropdown'">
			<!-- Eraser Button -->
			<div class="grid-cell indicator" v-if="col.search.filterRemovebtn">
				<button class="btn" type="button" @click="removeFilter(col)">
					<icon icon="fad fa-times" />
				</button>
			</div>

			<!-- Filter Mode Dropdown -->
			<div class="input-group-prepend mr-0">
				<div class="grid-cell indicator" v-if="col.search.searchable" ref="dropdown">
					<!-- Dropdown Button -->
					<button class="btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ref="filterButton" data-offset="-86">
						<icon icon="filter" />
					</button>

					<!-- Number Filter Mode -->
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-if="col.type === 'number' || col.type === 'price'" ref="dropdownItems">
						<a class="dropdown-item" name="number-filter-mode" :col-name="col.name" :col-id="col.id" @click="selectFilterMode(filterMode.mode, col, $event)" v-for="filterMode in numberFilterModes" :key="filterMode.id" :mode-value="filterMode.mode">
							{{ filterMode.title }}
						</a>
					</div>

					<!-- String Filter Mode -->
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-if="col.type === 'string' || !col.type" ref="dropdownItems">
						<a class="dropdown-item" name="string-filter-mode" :col-name="col.name" :col-id="col.id" @click="selectFilterMode(filterMode.mode, col, $event)" v-for="filterMode in stringFilterModes" :key="filterMode.id" :mode-value="filterMode.mode">
							{{ filterMode.title }}
						</a>
					</div>

					<!-- Date Filter Mode -->
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-if="col.type === 'pdate'" ref="dropdownItems">
						<a class="dropdown-item" name="date-filter-mode" :col-name="col.name" :col-id="col.id" @click="selectFilterMode(filterMode.mode, col, $event)" v-for="filterMode in dateFilterModes" :key="filterMode.id" :mode-value="filterMode.mode">
							{{ filterMode.title }}
						</a>
					</div>
				</div>
			</div>

			<!-- Filter Input -->
			<input @blur="searchBlur" v-show="col.type !== 'pdate' && !isRange" :type="col.type === 'number' ? 'number' : 'text'" class="search-input form-control pr-3" :col-name="col.name" :col-id="col.id" ref="searchInput" :disabled="!col.search.searchable ? true : null" :class="!col.search.searchable ? 'input-disable' : ''" />
			<input @blur="searchBlur" v-show="isRange" :value="$t('range-field')" disabled class="search-input form-control input-disable" />

			<!-- Date Filter -->
			<nk-date v-show="col.type === 'pdate' && !isRange" :options="{ startDate: '' }" @search-blur="searchBlur" class="search-input form-control nk-date" ref="dateComponent"></nk-date>

		</div>

		<!-- Dropdown Filter -->
		<select @change="searchBlur" ref="searchInput" :col-name="col.name" :col-id="col.id" class="search-input filter-select" v-if="col.type === 'dropdown' && readyDropDownData">
			<option :value="''" selected></option>
			<option v-for="(data, index) in dropDownData" :key="index" :value="data.value">
				{{ data.translated }}
			</option>
		</select>
	</div>
</template>

<script>
	import getLodash from 'lodash/get'
	import searchRange from './search-range.vue'

	export default {
		name: 'FilterRow',

		// Props
		props: {
			col: {
				type: Object,
				default() {
					return {}
				}
			},

			filteredData: {
				type: Array,
				default() {
					return []
				}
			},
		},

		emits: ['select-filter-mode', 'remove-grid-filter', 'search-blur', 'search-filter-mode', 'remove-filter'],

		// Computed
		computed: {
			dateInput() {
				if (this.$refs.dateComponent) {
					return this.$refs.dateComponent.$refs.input
				}
				return false
			}
		},

		// watch
		watch: {
			filteredData: {
				deep: true,
				handler(val) {
					if (this.dropDownData.length <= 0 && val.length > 0) {
						if (
							this.col.search.items.length > 0 &&
							this.col.type === 'dropdown'
						) {
							this.dropDownData = this.prepareDropdownData()
						}
					}
				}
			}
		},

		// Data
		data() {
			return {
				selectedRange: {},
				isRange: false,
				numberFilterModes: [
					{ id: 0, title: this.$t('equal'), mode: '===' },
					{ id: 1, title: this.$t('biggerThan'), mode: '>' },
					{ id: 2, title: this.$t('smallerThan'), mode: '<' },
					{ id: 3, title: this.$t('biggerThanEqual'), mode: '>=' },
					{ id: 4, title: this.$t('smallerThanEqual'), mode: '<=' },
					{ id: 5, title: this.$t('range'), mode: 'range' }
				],
				stringFilterModes: [
					{ id: 0, title: this.$t('equal'), mode: '===' },
					{ id: 1, title: this.$t('contain'), mode: 'indexOf' },
					{ id: 2, title: this.$t('endWith'), mode: 'endWith' },
					{ id: 3, title: this.$t('startWith'), mode: 'startWith' }
				],
				dateFilterModes: [
					{ id: 0, title: this.$t('equal'), mode: '===' },
					{ id: 1, title: this.$t('beforeThan'), mode: 'before' },
					{ id: 2, title: this.$t('afterThan'), mode: 'after' },
					{ id: 3, title: this.$t('range'), mode: 'range' }
				],
				dropDownData: [],
				readyDropDownData: false
			}
		},

		// Mounted
		mounted() {
			if (this.dateInput && this.dateInput.getAttribute('col-name') == null) {
				this.dateInput.setAttribute('col-name', this.col.name)
				this.dateInput.setAttribute('ref', 'searchInput')
				this.dateInput.setAttribute('col-id', this.col.id)
				this.dateInput.setAttribute('input-name', 'date')
			}

			this.dropDownData = this.prepareDropdownData()
		},

		// Methods
		methods: {
			selectFilterMode(mode, col, event) {
				if (mode === 'range') {
					this.removeFilter(col)
					this.showModal({
						component: searchRange,
						options: {
							range: this.selectedRange,
							mode: event.target.name,
						}
					})
						.then((res) => {
							event.target.value = res
							this.isRange = true
							this.selectedRange = res
							this.$emit('search-blur', event)
						})
						.catch((err) => {
							this.removeFilter(col)
							this.$emit('remove-grid-filter')
							return
						})
				}
				else
					this.isRange = false

				this.$emit('select-filter-mode', event)
				this.activeClassManager()
			},

			activeClassManager() {
				for (
					let index = 0;
					index < this.$refs.dropdownItems.children.length;
					index++
				) {
					const item = this.$refs.dropdownItems.children[index]
					if (item.getAttribute('mode-value') !== this.col.search.filterType) {
						if (item.className.includes('active')) {
							item.classList.remove('active')
						}
					} else {
						item.classList.add('active')
					}
				}
			},

			searchBlur(event) {
				this.$emit('search-blur', event)
			},

			removeFilter(col) {
				this.isRange = false
				col.search.filterRemovebtn = false
				col.search.filterType = null
				if (col.type === 'pdate') {
					this.dateInput.value = '----/--/--'
					this.$emit('remove-filter', this.dateInput)
				} else {
					this.$refs.searchInput.value = ''
					this.$emit('remove-filter', this.$refs.searchInput)
				}

				this.activeClassManager()
			},

			getElement() {
				if (this.col.type === 'pdate') {
					return this.dateInput
				} else {
					return this.$refs.searchInput
				}
			},
			isRangeToggler(mode) {
				this.isRange = mode
			},
			prepareDropdownData() {
				let data = null
				if (!this.col.search.searchFields) {
					data = this.col.search.items
				} else {
					data = this.col.search.items.filter(x => x != null).map((data) =>
						getLodash(data, this.col.search.searchFields)
					)
				}
				data = [...new Set(data)]
				if (this.col.search.useTranslate) {
					if (this.col.search.prefix == null) {
						this.col.search.prefix = ''
					}
					let translated
					data = data.map(value => {
						if (typeof value === 'string')
							value = value.toLowerCase()

						translated = this.$t(this.col.search.prefix + this.col.search.translateSplitter + value)
						return {
							value: this.col.search.useTranslate ? translated : value,
							translated: translated
						}
					})
				}
				this.readyDropDownData = true
				return data
			}
		}
	}
</script>

<style scoped>
	.dropdown-item {
		cursor: pointer;
	}

	.input-group {
		-webkit-box-align: center;
		align-items: center;
	}

	.form-control,
	.btn {
		box-shadow: unset !important;
	}

	.dropdown-menu {
		text-align: right !important;
	}

	.nk-date div input {
		border: none !important;
		padding-right: 12px !important;
	}

	#filter-row .input-disable {
		font-size: 11px;
	}
</style>
